import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selected: {},
};

const reducers = {
  RESET_SELECTED_ENTITIES: () => {
    return initialState;
  },
  SET_SELECTED_ENTITIES: (state, { payload }) => {
    state.selected[payload.name] = payload.items;
  },
};

const slice = createSlice({
  name: "ENTITIES",
  initialState,
  reducers,
});

export const { actions: entitiesActions, reducer: entitiesReducer } = slice;
